import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { MainService } from 'src/app/services/main.service'

import { SharedModule } from '../shared/shared.module'
import { BuyButtonComponent } from './components/buy-button/buy-button.component'
import { CompareButtonComponent } from './components/compare-button/compare-button.component'
import { DashboardStatsComponent } from './components/dashboard-stats.component'
import { DashboardComponent } from './dashboard.component'
import { DashboardService } from './dashboard.service'

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardStatsComponent,
    BuyButtonComponent,
    CompareButtonComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [DashboardComponent, BuyButtonComponent, CompareButtonComponent],
  providers: [MainService, DashboardService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}
